// extracted by mini-css-extract-plugin
module.exports = {"left":"_2UTLI","center":"_2Jz5k","right":"_28iJA","onImage":"_2z_qb","offImage":"_25pay"};